module.exports = __webpack_public_path__ + "static/media/new-banner-hires.7a970163.webp";